






























import {
    defineComponent,
    ref,
    computed,
    onMounted,
    onUnmounted,
} from '@vue/composition-api';
import { SdsButton } from '@superbet-group/web.lib.ui-components';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { HistoryType } from '@store/modules/ui/user/history/enums';
import { Product } from '@app/router/products/Product';
import { currentSite } from '@app/utils/domainHelpers';
import countryIndex from '@store/modules/data/country/countryIndex';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import { Site } from '@superbet-group/web.types';
import { getConfig } from '@superbet-group/web.lib.config';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export default defineComponent({
    name: 'HistoryContainer',
    setup() {
        const isAllTransactionsEnabled = ref(false);
        const configStore = useVuexStore<typeof countryIndex>('data/country');
        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const config = configStore.getter('config');
        const setModal = modalModule.action('setModal');
        let featureAllTransactionsSubscriptionUnsubscribeFn: () => void;

        onMounted(() => {
            featureAllTransactionsSubscriptionUnsubscribeFn = featureFlagService.subscribeToFeatureChanges(
                'wallet.transactionHistory.isEnabled',
                (isEnabled) => {
                    isAllTransactionsEnabled.value = isEnabled;
                },
                false,
            );
        });

        onUnmounted(() => {
            featureAllTransactionsSubscriptionUnsubscribeFn?.();
        });

        const isLiveDealerEnabled = computed(() => config.value.games.liveDealerEnabled);

        const items = computed(() => {
            const config = getConfig();
            const items = [
                {
                    type: HistoryType.transactions,
                    description: 'wallet.history.paymentsHistory.description',
                    title: 'wallet.history.paymentsHistory',
                },
            ];
            if ((Product.Sport || Product.Lottery)
                && ![
                    Site.NapoleonDice,
                    Site.NapoleonCasino,
                ].includes(currentSite)) {
                items.push({
                    type: HistoryType.bets,
                    // TODO: Update translation and key
                    description: 'wallet.history.sportsBetsHistory.description',
                    title: 'bets history',
                });
            }
            if (currentSite !== Site.NapoleonSports) {
                items.push({
                    type: HistoryType.casinoPlays,
                    description: 'wallet.history.casinoBetsHistory.description',
                    title: 'casino history',
                });
            }
            if (isLiveDealerEnabled.value) {
                items.push({
                    type: HistoryType.liveDealer,
                    description: 'here you can track the history of all card games plays',
                    title: 'card games history',
                });
            }
            if (isAllTransactionsEnabled.value && config.countrySpecific.user.history.availableTypes?.allTransactions) {
                items.push({
                    type: HistoryType.allTransactions,
                    description: 'wallet.history.transactionsHistory.description',
                    title: 'transactions history',
                });
            }
            return items.filter((item) => config.countrySpecific.user.history.availableTypes[item.type]);
        });

        const showTransactions = (type: HistoryType) => {
            const title = {
                [HistoryType.transactions]: 'wallet.history.paymentsHistory',
                [HistoryType.bets]: 'bets history',
                [HistoryType.casinoPlays]: 'casino history',
                [HistoryType.liveDealer]: 'card games history',
                [HistoryType.allTransactions]: 'transactions history',
            }[type];

            const currencyDisplay = {
                [HistoryType.transactions]: 'cutoff',
                [HistoryType.bets]: 'round',
                [HistoryType.casinoPlays]: 'round',
                [HistoryType.liveDealer]: 'round',
                [HistoryType.allTransactions]: 'cutoff',
            }[type];

            setModal({
                code: type === HistoryType.allTransactions ? modalCodes.allTransactionHistory : modalCodes.transactionHistory,
                data: {
                    title,
                    type,
                    currencyDisplay,
                },
            });
        };

        return {
            isAllTransactionsEnabled,
            isLiveDealerEnabled,
            items,
            showTransactions,
        };
    },
    components: {
        SdsButton,
    },
});
